module.exports = __webpack_public_path__ + "static/media/login-promotor.2ced570c.png";